import { render, staticRenderFns } from "./detaliModel.vue?vue&type=template&id=5dcdb6a1&scoped=true&"
import script from "./detaliModel.vue?vue&type=script&lang=js&"
export * from "./detaliModel.vue?vue&type=script&lang=js&"
import style0 from "./detaliModel.vue?vue&type=style&index=0&id=5dcdb6a1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcdb6a1",
  null
  
)

export default component.exports